import { useCallback, useEffect, useRef, useState } from 'react';
import { toast } from 'sonner';
import { api } from './utils';

export const useRefreshJob = (onDone) => {
  const [running, setRunning] = useState(false);
  const [stage, setStage] = useState('');
  const timer = useRef(null);

  const poll = useCallback((jobId) => {
    setRunning(true);
    clearInterval(timer.current);
    timer.current = setInterval(async () => {
      try {
        const job = await api(`/refresh/status${jobId ? `?job_id=${jobId}` : ''}`);
        setStage(job.stage || '');
        if (job.status === 'running') return;
        clearInterval(timer.current);
        setRunning(false);
        setStage('');
        if (job.status === 'completed') { toast.success('Refreshed from Halaxy'); onDone(); }
        else toast.error('Refresh failed', { description: job.error || 'Check the Halaxy connection.' });
      } catch (e) { /* transient — keep polling */ }
    }, 3000);
  }, [onDone]);

  const start = useCallback(async () => {
    try {
      const res = await api('/refresh', { method: 'POST' });
      setStage('Starting…');
      poll(res.job_id);
    } catch (e) { toast.error(e.message); }
  }, [poll]);

  useEffect(() => {
    api('/refresh/status').then((job) => job.status === 'running' && poll(job.job_id)).catch(() => {});
    return () => clearInterval(timer.current);
  }, [poll]);

  return { running, stage, start };
};
